import { Shell } from "./Shell";
import { FadeUp } from "./Sections";

const LegalShell = ({ kicker, title, children, testid }) => (
  <Shell>
    <div className="mx-auto max-w-3xl px-6 py-16 md:py-24" data-testid={testid}>
      <FadeUp>
        <p className="mb-5 flex items-center text-xs font-bold uppercase tracking-[0.18em] text-[#004778]">
          <span className="mr-2.5 inline-block h-2.5 w-2.5 bg-[#FFA100]" aria-hidden="true" />
          {kicker}
        </p>
        <h1 className="harc-heading text-4xl font-medium leading-[1.1] tracking-tight text-[#004778] md:text-5xl">
          {title}
        </h1>
      </FadeUp>
      <div className="mt-10 space-y-8">{children}</div>
    </div>
  </Shell>
);

const Section = ({ title, children }) => (
  <section>
    <h2 className="harc-heading text-xl font-medium text-[#004778]">{title}</h2>
    <div className="mt-3 space-y-3 text-sm leading-relaxed text-[#5C6B72]">{children}</div>
  </section>
);

const Placeholder = ({ children }) => (
  <p className="border-l-4 border-[#FFA100] bg-[#004778]/5 p-4 text-xs italic">{children}</p>
);

export const Privacy = () => (
  <LegalShell kicker="Legal" title="Privacy Policy" testid="privacy-page">
    <Placeholder>
      [HARC CONTENT REQUIRED: approved privacy policy covering data collected via the Start a
      Conversation form (Gravity Forms entries), Mailchimp newsletter signup, Qgiv donations, and
      Google Analytics.]
    </Placeholder>
    <Section title="What this policy will cover">
      <p>
        Information collected through forms and newsletter signup; how HARC uses and protects it;
        cookie and analytics practices; third-party processors (Mailchimp, Qgiv, Google); how to
        request access or deletion of your information.
      </p>
    </Section>
  </LegalShell>
);

export const Terms = () => (
  <LegalShell kicker="Legal" title="Terms of Use" testid="terms-page">
    <Placeholder>
      [HARC CONTENT REQUIRED: approved terms of use covering website content, intellectual
      property, acceptable use, disclaimers, and limitation of liability.]
    </Placeholder>
    <Section title="What these terms will cover">
      <p>
        Ownership and permitted use of HARC reports, data, and publications; disclaimer of
        warranties; links to third-party sites; governing law.
      </p>
    </Section>
  </LegalShell>
);

export const Accessibility = () => (
  <LegalShell kicker="Our Commitment" title="Accessibility Statement" testid="accessibility-page">
    <Section title="Our commitment">
      <p>
        HARC is committed to ensuring this website is accessible to all visitors. This site is
        designed and built toward WCAG 2.2 Level AA conformance, including keyboard-navigable
        menus and dialogs, visible focus states, color-contrast-checked brand colors, alternative
        text on imagery, and transcripts for podcast and video content.
      </p>
    </Section>
    <Section title="Feedback">
      <p>
        If you encounter an accessibility barrier, please contact us and we will work to resolve it
        promptly.
      </p>
      <Placeholder>
        [HARC CONTENT REQUIRED: accessibility contact email/phone and formal review process.]
      </Placeholder>
    </Section>
    <Section title="Known limitations">
      <p>
        This statement is a draft for the redesigned website and will be finalized with a formal
        conformance review before launch.
      </p>
    </Section>
  </LegalShell>
);
